import { Row } from 'react-table';
import { getShortDate } from '../../../Utils/UtilFunctions';
import { Change } from '../Change';
import { SILVER_DATA } from '../types';
import { checkNumberSign } from '../utils';
import { addCommasToNumber } from '../../../Utils/CommonUtils';

interface COLUMN_TYPE {
  Header: string | JSX.Element;
  accessor: string;
  Cell: ({ row }: { row: Row<SILVER_DATA> }) => JSX.Element;
}

const TableHeader = ({ text }: { text: string }): JSX.Element => {
  return <span className="text-base text-font-500 font-bold">{text}</span>;
};

export const CITY_WISE_SILVER_COLUMN = [
  {
    Header: <TableHeader text="City" />,
    accessor: 'city',
    Cell: ({ row }) => {
      return (
        <span className="text-s-14 font-semibold capitalize">
          {row.original.city}
        </span>
      );
    },
  },
  {
    Header: <TableHeader text="10 gram" />,
    accessor: '10gram',
    Cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex gap-2 items-center text-s-14">
          <span>₹{addCommasToNumber(data.ratePerGram * 10)}</span>
          <Change
            sign={checkNumberSign(data.change)}
            change={data.change * 10}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
  {
    Header: <TableHeader text="1 kilogram" />,
    accessor: '1kg',
    Cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex gap-2 items-center text-s-14">
          <span>₹{addCommasToNumber(data.ratePerGram * 1000)}</span>
          <Change
            sign={checkNumberSign(data.change)}
            change={data.change * 1000}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
] as COLUMN_TYPE[];

export const GRAM_WISE_SILVER_COLUMN = [
  {
    Header: <TableHeader text="1 g" />,
    accessor: 'rate*1',
    Cell: ({ row }) => {
      const rate = addCommasToNumber(Math.floor(row.original.ratePerGram * 1));
      const change = Math.floor(row.original.change * 1);

      return (
        <div className="flex gap-2 items-center text-s-12">
          <span className="text-s-14">₹{rate}</span>
          <Change
            sign={checkNumberSign(change)}
            change={change}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
  {
    Header: <TableHeader text="10 g" />,
    accessor: 'rate*10',
    Cell: ({ row }) => {
      const rate = addCommasToNumber(Math.floor(row.original.ratePerGram * 10));
      const change = Math.floor(row.original.change * 10);

      return (
        <div className="flex gap-2 items-center text-s-12">
          <span className="text-s-14">₹{rate}</span>
          <Change
            sign={checkNumberSign(change)}
            change={change}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
  {
    Header: <TableHeader text="100 g" />,
    accessor: 'rate*100',
    Cell: ({ row }) => {
      const rate = addCommasToNumber(
        Math.floor(row.original.ratePerGram * 100)
      );
      const change = Math.floor(row.original.change * 100);

      return (
        <div className="flex gap-2 items-center text-s-12">
          <span className="text-s-14">₹{rate}</span>
          <Change
            sign={checkNumberSign(change)}
            change={change}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
  {
    Header: <TableHeader text="1 kg" />,
    accessor: 'rate*1000',
    Cell: ({ row }) => {
      const rate = addCommasToNumber(
        Math.floor(row.original.ratePerGram * 1000)
      );
      const change = Math.floor(row.original.change * 1000);

      return (
        <div className="flex gap-2 items-center text-s-12">
          <span className="text-s-14">₹{rate}</span>
          <Change
            sign={checkNumberSign(change)}
            change={change}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
] as COLUMN_TYPE[];

export const LAST_10_DAYS_SILVER_RATE_COLUMN = [
  {
    Header: <TableHeader text="Date" />,
    accessor: 'date',
    Cell: ({ row }) => {
      return (
        <span className="text-s-14 font-semibold capitalize">
          {getShortDate(row.original.date)}
        </span>
      );
    },
  },
  {
    Header: <TableHeader text="10 gram" />,
    accessor: 'ratePerGram*10',
    Cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex gap-2 items-center text-s-14">
          <span>₹{addCommasToNumber(data.ratePerGram * 10)}</span>
          <Change
            sign={checkNumberSign(data.change)}
            change={data.change * 10}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
  {
    Header: <TableHeader text="1 kilogram" />,
    accessor: 'ratePerGram*1000',
    Cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="flex gap-2 items-center text-s-14">
          <span>₹{addCommasToNumber(data.ratePerGram * 1000)}</span>
          <Change
            sign={checkNumberSign(data.change * 1000)}
            change={data.change * 1000}
            showInBrackets={true}
            isSmall={true}
          />
        </div>
      );
    },
  },
] as COLUMN_TYPE[];
